import { combineReducers } from '@reduxjs/toolkit'

import { reducer as rateAnswers } from './rateAnswers'
import { reducer as questions } from './questions'

export default combineReducers({ rateAnswers, questions })
